import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgQuestionCircleWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <circle cx={8} cy={8} r={7.5} stroke="#fff" />
    <path
      fill="#fff"
      d="m7.665 9.78.732-.312c-.204-.156-.324-.396-.324-.588 0-1.176 2.327-1.332 2.327-3.144 0-1.032-.887-1.86-2.351-1.86-1.14 0-2.028.48-2.604 1.224l.6.648c.444-.588 1.008-.984 1.908-.984.948 0 1.416.516 1.416 1.116 0 1.272-2.172 1.404-2.172 2.928 0 .36.144.696.468.972zm.252 2.34c.36 0 .66-.3.66-.66 0-.36-.3-.66-.66-.66-.36 0-.66.3-.66.66 0 .36.3.66.66.66z"
    />
  </svg>
);
const Memo = memo(SvgQuestionCircleWhite);
export default Memo;
